import { Box, Container } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Button from "../../components/ui/Button";
import Text from "../../components/ui/Text";
import { ROUTES } from "../../constants/routes";

const EmailConfirmed = () => {
  const navigate = useNavigate();

  const handleContinue = () => {
    navigate(ROUTES.SIGNIN, { replace: true });
  };

  return (
    <Container>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          mx: "auto",
        }}
      >
        {/* Success Icon */}
        <Box
          sx={{
            width: 100,
            height: 100,
            borderRadius: "50%",
            backgroundColor: "#E6F7FF",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mb: 3,
          }}
        >
          <svg
            width="50"
            height="50"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9 16.17L4.83 12L3.41 13.41L9 19L21 7L19.59 5.59L9 16.17Z"
              fill="#1890FF"
            />
          </svg>
        </Box>

        {/* Header */}
        <Text variant="pageHeader" sx={{ mb: 2 }}>
          Email Verified!
        </Text>

        {/* Description */}
        <Text
          variant="paragraph"
          sx={{
            color: "#666666",
            mb: 4,
            lineHeight: 1.6,
          }}
        >
          Your email has been successfully verified. You can now sign in to your
          account and start using Findaside.
        </Text>

        {/* Continue Button */}
        <Button
          variant="primary"
          onClick={handleContinue}
          sx={{
            minWidth: "200px",
          }}
        >
          Continue to Sign In
        </Button>
      </Box>
    </Container>
  );
};

export default EmailConfirmed;
